const commaTransformator = {
  toModelAttribute(value) {
    if (value == null || value === "") {
      return null;
    }
    if (typeof value === "number") {
      return value;
    }

    const res = parseFloat(value.replace(",", "."));
    if (Number.isNaN(res)) {
      return null;
    }

    return res;
  },

  toFormAttribute(value) {
    if (value == null) {
      return "";
    }

    return `${value}`.replace(".", ",");
  },
};

export default commaTransformator;
